<template>
  <div id="Couriers">
    <BreadCrumb :items="breadcrumbItems" />

    <v-card elevation="1" class="pt-5 mt-1">
      <div class="header d-flex justify-space-between pr-5 align-center">
        <h1>Lista de entregadores</h1>
        <router-link to="/couriers/new">
          <v-btn elevation="2" color="success" large>NOVO ENTREGADOR</v-btn>
        </router-link>
      </div>

      <div class="table mt-10">
        <v-data-table
          :headers="headers"
          :items="desserts"
          :loading="loading"
          :items-per-page="paginate.pageSize"
          @update:items-per-page="changeItemsPerPage"
          :footer-props="{
            'items-per-page-options': [10, 20, 30, 50],
            itemsPerPageText: 'Itens por página'
          }"
        >
          <template v-slot:[`item.disabled`]="{ item, index }">
            <v-switch
              v-model="item.disabled"
              :false-value="true"
              :true-value="false"
              inset
              color="success"
              readonly
              @click.stop.prevent="openDialogStatus(item, index)"
            ></v-switch>
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <div class="d-flex align-center">
              <router-link class="pr-3" :to="`/couriers/${item.id}`">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <PencilSVG v-bind="attrs" v-on="on" />
                  </template>
                  <span>Editar</span>
                </v-tooltip>
              </router-link>
              <router-link class="pr-2" :to="`/couriers/${item.id}/details`">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <ViewSVG v-bind="attrs" v-on="on" />
                  </template>
                  <span>Detalhes</span>
                </v-tooltip>
              </router-link>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <TrashSVG
                    class="ml-1"
                    role="button"
                    @click.stop.prevent="openDialogTrash(item)"
                    title="Deletar"
                    v-bind="attrs"
                    v-on="on"
                  />
                </template>
                <span>Deletar</span>
              </v-tooltip>
            </div>
          </template>
        </v-data-table>
        <v-pagination v-model="page" :length="paginate.totalPages" :total-visible="7"></v-pagination>
      </div>
    </v-card>

    <v-dialog v-model="dialogStatus" persistent max-width="450">
      <v-card class="align-center text-center">
        <v-card-title class="headline justify-center"> Mudar status do usuário? </v-card-title>
        <v-card-text>
          Você confirma estar mudando o status do entregador
          {{ statusItem.name }}
        </v-card-text>
        <v-card-actions class="d-flex justify-space-between pb-5">
          <v-btn color="error" class="flex-grow-1" @click="dialogStatus = false"> Cancelar </v-btn>
          <v-btn color="success" class="flex-grow-1" @click="toggleItem()"> Confirmar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogTrash" persistent max-width="450">
      <v-card class="align-center text-center">
        <v-card-title class="headline justify-center"> Deletar usuário? </v-card-title>
        <v-card-text>
          Você confirma estar deletando o entregador
          {{ trashItem.name }}
        </v-card-text>
        <v-card-actions class="d-flex justify-space-between pb-5">
          <v-btn color="error" class="flex-grow-1" @click="dialogTrash = false"> Cancelar </v-btn>
          <v-btn color="success" class="flex-grow-1" @click="deleteItem()"> Confirmar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <MessagesError :errors="errors" :type="errorsType" :error500="error500" @closeMessages="errors = []" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex';

import BreadCrumb from '../../../components/BreadCrumb.vue';
import MessagesError from '../../../components/MessagesError.vue';

// SVGs
import PencilSVG from '../../../assets/img/pencil.svg';
import TrashSVG from '../../../assets/img/trash.svg';
import ViewSVG from '../../../assets/img/view.svg';

export default {
  name: 'Users',
  components: {
    BreadCrumb,
    MessagesError,
    PencilSVG,
    TrashSVG,
    ViewSVG
  },
  data: () => ({
    loading: true,
    dialogTrash: false,
    trashItem: {},
    dialogStatus: false,
    statusItem: {},
    errors: [],
    errorsType: null,
    error500: null,
    breadcrumbItems: [
      {
        text: 'Início',
        disabled: false,
        to: '/start'
      },
      {
        text: 'Entregadores',
        disabled: true,
        to: '/couriers'
      }
    ],
    headers: [
      { text: 'NOME', value: 'name', align: 'start' },
      { text: 'APELIDO', value: 'nickName' },
      { text: 'PLACA DO VEÍCULO', value: 'plate' },
      { text: 'CIDADE', value: 'city' },
      { text: 'STATUS', value: 'disabled' },
      { text: 'AÇÕES', value: 'actions' }
    ]
  }),
  computed: {
    ...mapState('CouriersStore', ['paginate']),
    ...mapGetters('CouriersStore', ['getCouriers']),
    page: {
      get() {
        return this.paginate.pageNumber;
      },
      set(value) {
        this.setPageNumber(value);

        this.fetchAllCouriers();
      }
    },
    desserts() {
      return this.getCouriers;
    }
  },
  mounted() {
    this.fetchAllCouriers();
  },
  methods: {
    ...mapActions('CouriersStore', ['fetchCouriers', 'toggleCourier', 'deleteCourier']),
    ...mapMutations('CouriersStore', [
      'setCouriers',
      'toggleDisableCourier',
      'trashCourier',
      'setItemPerPage',
      'setPageNumber'
    ]),
    async fetchAllCouriers() {
      this.loading = true;
      try {
        await this.fetchCouriers();
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
    async deleteItem() {
      this.loading = true;

      try {
        await this.deleteCourier(this.trashItem.id);

        this.trashCourier(this.trashItem.id);
        this.fetchAllCouriers();
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
        this.dialogTrash = false;
      }
    },
    openDialogTrash(item, index) {
      this.dialogTrash = true;
      this.trashItem = {
        ...item,
        index
      };
    },
    openDialogStatus(item, index) {
      this.dialogStatus = true;
      this.statusItem = {
        ...item,
        index
      };
    },
    async toggleItem() {
      this.loading = true;

      try {
        const data = await this.toggleCourier(this.statusItem);

        if (data.success) {
          this.toggleDisableCourier(this.statusItem);
        } else {
          console.log(data.errors);
          this.errors = data.errors;
          this.errorsType = 'error';
        }
      } catch (err) {
        this.errors = ['Ops! Algo deu errado.'];
        this.errorsType = 'error';
        this.error500 = err;
      } finally {
        this.loading = false;
        this.dialogStatus = false;
      }
    },
    changeItemsPerPage(items) {
      this.setItemPerPage(items);

      this.fetchAllCouriers();
    }
  }
};
</script>

<style lang="scss">
#couriers {
}
</style>
